// 角色中文翻译
export default {
  // Trouble Brewing 角色
  washerwoman: {
    name: "洗衣妇",
    ability: "在游戏开始时，你会得知2名玩家中有1名特定的村民。",
  },
  librarian: {
    name: "图书管理员",
    ability:
      "在游戏开始时，你会得知2名玩家中有1名特定的外来者。（或是场上没有外来者。）",
  },
  investigator: {
    name: "调查员",
    ability: "在游戏开始时，你会得知2名玩家中有1名特定的爪牙。",
  },
  chef: {
    name: "厨师",
    ability: "在游戏开始时，你会得知有多少对邪恶玩家相邻。",
  },
  empath: {
    name: "共情者",
    ability: "每个夜晚，你会得知与你邻近的2名存活的玩家中有几个是邪恶的。",
  },
  fortuneteller: {
    name: "占卜师",
    ability:
      "每个夜晚，选择2名玩家：你会得知他们之中是否有恶魔。会有一名善良玩家对你来说是恶魔。",
  },
  undertaker: {
    name: "送葬者",
    ability: "每个夜晚*，你会得知今天白天死于处决的角色。",
  },
  monk: {
    name: "僧侣",
    ability:
      "每个夜晚*，选择一名玩家（不能是你自己）：该玩家在今晚免受恶魔袭击。",
  },
  ravenkeeper: {
    name: "守鸦人",
    ability: "如果你在夜晚死亡，你会被唤醒并选择一名玩家：你会得知他的角色。",
  },
  virgin: {
    name: "贞洁者",
    ability: "第一次有人提名你时，如果提名者是村民，他立即被处决。",
  },
  slayer: {
    name: "猎魔人",
    ability:
      "每局游戏一次，在白天时段，你可以公开选择一名玩家：如果他是恶魔，他死亡。",
  },
  soldier: {
    name: "士兵",
    ability: "你不会死于恶魔的袭击。",
  },
  mayor: {
    name: "镇长",
    ability:
      "如果只有3名玩家存活且没有处决发生，你的阵营获胜。如果你在夜晚死亡，可能会有另一名玩家代替你死亡。",
  },
  butler: {
    name: "管家",
    ability:
      "每个夜晚，选择一名玩家（不能是你自己）：明天，只有在他投票时你才能投票。",
  },
  drunk: {
    name: "酒鬼",
    ability: "你不知道你是酒鬼。你以为你是一个村民角色，但你不是。",
  },
  recluse: {
    name: "隐士",
    ability: "你可能被当作邪恶、爪牙或恶魔，即使你已经死亡。",
  },
  saint: {
    name: "圣徒",
    ability: "如果你死于处决，你的阵营失败。",
  },
  poisoner: {
    name: "投毒者",
    ability: "每个夜晚，选择一名玩家：该玩家在今晚和明天白天中毒。",
  },
  spy: {
    name: "间谍",
    ability:
      "每个夜晚，你可以查看魔典。你可能被当作善良、村民或外来者，即使你已经死亡。",
  },
  scarletwoman: {
    name: "猩红女郎",
    ability:
      "如果有5名或更多玩家存活且恶魔死亡，你变成恶魔。（旅行者不计入。）",
  },
  baron: {
    name: "男爵",
    ability: "游戏中额外有外来者。[+2个外来者]",
  },
  imp: {
    name: "小恶魔",
    ability:
      "每个夜晚*，选择一名玩家：该玩家死亡。如果你以此方式自杀，一名爪牙变成小恶魔。",
  },

  // Bad Moon Rising 角色
  grandmother: {
    name: "祖母",
    ability:
      "在游戏开始时，你会得知一名善良玩家和他的角色。如果恶魔杀死他们，你死亡。",
  },
  sailor: {
    name: "水手",
    ability:
      "每个夜晚，选择一名存活的玩家：你们其中一人醉酒直到黄昏。你无法死亡。",
  },
  chambermaid: {
    name: "女仆",
    ability:
      "每个夜晚，选择2名存活的玩家（不能是你自己）：你会得知他们之中有几个在今晚醒来。",
  },
  exorcist: {
    name: "驱魔人",
    ability:
      "每个夜晚*，选择一名玩家（不同于昨晚）：如果他是恶魔，他不会得知自己的选择，且今晚没有玩家死亡。",
  },
  innkeeper: {
    name: "旅店老板",
    ability:
      "每个夜晚*，选择2名玩家：他们今晚不会死于恶魔的袭击，但其中一人醉酒直到黄昏。",
  },
  gambler: {
    name: "赌徒",
    ability: "每个夜晚*，选择一名玩家并猜测他的角色：如果你猜错了，你死亡。",
  },
  gossip: {
    name: "八卦者",
    ability:
      "每个白天一次，你可以公开陈述。今晚，如果这是真的，有一名玩家死亡。",
  },
  courtier: {
    name: "侍臣",
    ability:
      "每局游戏一次，在夜晚，选择一名角色：如果他在场，他醉酒3个夜晚和3个白天。",
  },
  professor: {
    name: "教授",
    ability:
      "每局游戏一次，在夜晚*，选择一名死去的玩家：如果他是村民，他复活。",
  },
  minstrel: {
    name: "吟游诗人",
    ability:
      "当一名爪牙死于处决时，所有其他玩家（旅行者除外）醉酒直到黄昏明天。",
  },
  teaLady: {
    name: "茶艺师",
    ability: "如果你的两个存活的邻居都是善良的，他们无法死亡。",
  },
  pacifist: {
    name: "和平主义者",
    ability: "处决的善良玩家可能不会死亡。",
  },
  fool: {
    name: "愚者",
    ability: "首次你死亡时，你不会死。",
  },
  tinker: {
    name: "修补匠",
    ability: "你可能在任何时候死亡。",
  },
  moonchild: {
    name: "月之子",
    ability:
      "当你得知你死亡时，公开选择一名存活的玩家。今晚，如果他是善良的，他死亡。",
  },
  goon: {
    name: "打手",
    ability:
      "每个夜晚，第一个选择你的角色能力对你无效：如果这是邪恶玩家，他们醉酒直到黄昏。",
  },
  lunatic: {
    name: "疯子",
    ability: "你以为你是恶魔，但你不是。恶魔知道你是疯子。[+1个外来者]",
  },
  godfather: {
    name: "教父",
    ability:
      "在游戏开始时，你会得知哪些外来者在场。如果外来者在白天死亡，你会得知。[+1个外来者]",
  },
  devilsadvocate: {
    name: "魔鬼代言人",
    ability:
      "每个夜晚，选择一名存活的玩家（不同于昨晚）：如果他明天白天被处决，他不会死。",
  },
  assassin: {
    name: "刺客",
    ability: "每局游戏一次，在夜晚*，选择一名玩家：他死亡，即使有保护。",
  },
  mastermind: {
    name: "策划者",
    ability:
      "如果恶魔在白天死于处决，再多进行一天一夜的游戏，然后邪恶获胜。[所有的爪牙都没有【额外伤害】]",
  },
  zombuul: {
    name: "僵尸",
    ability:
      "每个夜晚*，如果没有人死亡，选择一名玩家：他死亡。第一次你死亡时，你在僵尸状态下继续存活。",
  },
  pukka: {
    name: "巫毒娃娃",
    ability: "每个夜晚，选择一名玩家：他中毒。先前中毒的玩家死亡然后清醒。",
  },
  shabaloth: {
    name: "贪食者",
    ability:
      "每个夜晚*，选择2名玩家：他们死亡。夜晚醒来时选择1名死去的玩家：他复活。",
  },
  po: {
    name: "破",
    ability:
      "每个夜晚*，你可以选择一名玩家：他死亡。如果你上个夜晚没有选择，今晚你选择3名玩家。",
  },

  // Sects & Violets 角色
  clockmaker: {
    name: "钟表匠",
    ability:
      "在游戏开始时，你会得知恶魔和最近的爪牙之间有多少个座位（顺时针或逆时针方向）。",
  },
  dreamer: {
    name: "梦想家",
    ability:
      "每个夜晚，选择一名玩家（不能是你自己或旅行者）：你会得知1个善良角色和1个邪恶角色，其中之一是他的角色。",
  },
  snakecharmer: {
    name: "弄蛇人",
    ability:
      "每个夜晚，选择一名存活的玩家：在本夜晚结束时，如果你选择了恶魔，你和他交换角色。",
  },
  mathematician: {
    name: "数学家",
    ability:
      "每个夜晚，你会得知有多少玩家的能力由于其他玩家能力的影响而出现了错误信息。",
  },
  flowergirl: {
    name: "花童",
    ability: "每个夜晚*，你会得知恶魔是否投了票。",
  },
  towncrier: {
    name: "城镇传令官",
    ability: "每个夜晚*，你会得知今天白天是否有一名爪牙提名。",
  },
  oracle: {
    name: "神谕者",
    ability: "每个夜晚*，你会得知有多少死去的玩家是邪恶的。",
  },
  savant: {
    name: "学者",
    ability: "每天，你可以访问说书人两次来询问是否问题，以得到是或否的答案。",
  },
  seamstress: {
    name: "裁缝",
    ability:
      "每局游戏一次，在夜晚，选择2名玩家（不能是你自己）：你会得知他们是否是同一阵营。",
  },
  philosopher: {
    name: "哲学家",
    ability:
      "每局游戏一次，在夜晚，选择一名善良角色：你获得该角色的能力。如果该角色在场，他醉酒。",
  },
  artist: {
    name: "艺术家",
    ability: "每局游戏一次，在白天，私下询问说书人一个是否问题。",
  },
  juggler: {
    name: "杂耍者",
    ability:
      "在你的首个白天，公开猜测最多5名玩家的角色。那天夜晚，你会得知你猜对了几个。",
  },
  sage: {
    name: "圣人",
    ability: "如果恶魔杀死你，你会得知哪2名玩家里有1个是恶魔。",
  },
  mutant: {
    name: "变种人",
    ability: "如果你是疯狂的外来者，你可能在任何时候被处决。",
  },
  sweetheart: {
    name: "甜心",
    ability: "当你死亡时，一名玩家醉酒直到黄昏明天。",
  },
  barber: {
    name: "理发师",
    ability:
      "如果你在白天死亡或夜晚死亡，恶魔可能选择2名玩家（不能是另一名恶魔）交换角色。",
  },
  klutz: {
    name: "笨蛋",
    ability:
      "当你得知你死亡时，你公开选择一名存活的玩家：如果他是邪恶的，你的阵营失败。",
  },
  eviltwin: {
    name: "邪恶双胞胎",
    ability:
      "你与一名对立的善良玩家知道对方是什么角色。如果善良双胞胎死于处决，邪恶获胜。好消息！[+1个善良玩家]",
  },
  witch: {
    name: "女巫",
    ability:
      "每个夜晚，选择一名玩家：如果他明天白天提名，他死亡。如果只有3名玩家存活，你失去这个能力。",
  },
  cerenovus: {
    name: "疯狂制造者",
    ability:
      "每个夜晚，选择一名玩家和一个角色：他'发疯'并认为他是这个角色明天。如果他不发疯，他可能在任何时候被处决。",
  },
  pithag: {
    name: "换身巫婆",
    ability:
      "每个夜晚*，选择一名玩家和一个角色：如果该角色不在场，他变成该角色。如果在场，双方死亡。",
  },
  fanggu: {
    name: "僵尸",
    ability:
      "每个夜晚*，选择一名玩家：他死亡。第一次你选择一名外来者时，他变成邪恶的你的角色。[+1个外来者]",
  },
  vigormortis: {
    name: "活尸",
    ability:
      "每个夜晚*，选择一名玩家：他死亡。被你杀死的爪牙保持他们的能力且中毒。[-1个外来者]",
  },
  nodashii: {
    name: "野武士",
    ability: "每个夜晚*，选择一名玩家：他死亡。你的邻居是中毒的。",
  },
  vortox: {
    name: "沃托克斯",
    ability:
      "每个夜晚*，选择一名玩家：他死亡。村民的能力产生虚假信息。每天必须进行处决否则你的阵营失败。",
  },

  // 旅行者
  bureaucrat: {
    name: "官僚",
    ability: "每个夜晚，选择一名玩家（不能是你自己）：他的投票明天计为3票。",
  },
  thief: {
    name: "小偷",
    ability: "每个夜晚，选择一名玩家（不能是你自己）：他的投票明天计为负数。",
  },
  gunslinger: {
    name: "枪手",
    ability: "每天，在第一次投票统计后，你可以选择一名投过票的玩家：他死亡。",
  },
  scapegoat: {
    name: "替罪羊",
    ability: "如果你阵营的玩家被处决，可能改为处决你。",
  },
  beggar: {
    name: "乞丐",
    ability:
      "你必须使用投票标记来投票。死去的玩家可以选择把他们的标记给你。如果这样，你会得知他们的阵营。你是清醒且健康的。",
  },
  apprentice: {
    name: "学徒",
    ability: "在你的首个夜晚，你获得一个村民能力（如果有善良玩家还活着）。",
  },
  matron: {
    name: "女主管",
    ability:
      "每个白天，你可以选择最多3名善良玩家来学习一套角色，其中一个是正确的。",
  },
  judge: {
    name: "法官",
    ability:
      "每局游戏一次，如果进行了处决但没有人死亡，你可以选择一名玩家。他死亡。",
  },
  bishop: {
    name: "主教",
    ability: "只有说书人可以提名。至少1名对立玩家必须提名每天。",
  },
  voudon: {
    name: "巫毒师",
    ability:
      "只有你和死去的玩家可以投票。他们不能提名。出现并列票时，你决定谁死亡。",
  },

  // 传奇角色
  doomsayer: {
    name: "末日预言者",
    ability:
      "如果有4名或更多玩家存活，每名存活的玩家可以公开选择（每局游戏一次）一名与自己同一阵营的玩家死亡。",
  },
  angel: {
    name: "天使",
    ability: "对导致新玩家死亡负有最大责任的人可能会发生不好的事情。",
  },
  buddhist: {
    name: "佛教徒",
    ability: "在每天的前2分钟，老玩家不能说话。",
  },
  hellslibrarian: {
    name: "地狱图书管理员",
    ability: "当说书人要求保持安静时说话的人可能会发生不好的事情。",
  },
  revolutionary: {
    name: "革命者",
    ability:
      "已知2名相邻的玩家是同一阵营。每局游戏一次，其中一人的检测结果可能是虚假的。",
  },
  fiddler: {
    name: "小提琴手",
    ability:
      "每局游戏一次，恶魔秘密选择一名对立玩家：所有玩家选择这2名玩家中哪个获胜。",
  },
  toymaker: {
    name: "玩具匠",
    ability:
      "恶魔可以选择不攻击，且必须至少选择一次。邪恶玩家获得正常的初始信息。",
  },
  fibbin: {
    name: "说谎者",
    ability: "每局游戏一次，1名善良玩家可能获得虚假信息。",
  },
  duchess: {
    name: "公爵夫人",
    ability:
      "每天，3名玩家可以选择拜访你。在夜晚*，每名访客得知有多少访客是邪恶的，但1人得到虚假信息。",
  },
  sentinel: {
    name: "哨兵",
    ability: "游戏中可能多1个或少1个外来者。",
  },
  spiritofivory: {
    name: "象牙之灵",
    ability: "不能有超过1个额外的邪恶玩家。",
  },
  djinn: {
    name: "精灵",
    ability: "使用精灵的特殊规则。所有玩家知道这是什么。",
  },
  stormcatcher: {
    name: "捕风者",
    ability:
      "说出一个善良角色。如果在场，他只能死于处决，但邪恶玩家会得知是哪个玩家。",
  },
};
